<template>
    <div>
        <div class="content-header text-center">
            <h2>Email Append Lookup</h2>
        </div>
        <div class="my-5">
        </div>
        <div class="container-fluid min-content-height">
        <p class="lead">Do not close this window until the process is complete</p>
        <h3>Status: <span v-if="this.thestatus == false">Processing...</span><span v-if="this.thestatus == true">Success</span></h3>
        <p>{{messageTxt}} <span v-if="this.fincount >= 1"> {{fincount}} found</span></p>
        <a v-if="this.finalFilePath" class="btn btn-lg btn-primary" v-bind:href="'/download_appended_result?appended='+removePath(this.finalFilePath)"  v-bind:download="removePath(this.finalFilePath)" target="_blank">Download Appended {{removePath(this.finalFilePath)}}</a>
        <button v-if="this.finalFilePath" class="btn btn-lg btn-warning" @click="$emit('customChange', {shell: 'EmailAppendBulk', dataset: ''})">Email Append Dashboard</button>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
//import useVuelidate from '@vuelidate/core'
//import { required } from '@vuelidate/validators'
export default {
    name: 'EmailUploadBulk',
    props: {
        emailAppendFile: '',
        userSubscription: [],
        emaillistsend: [],
        appendFilerange: '',
        passedData: [{
            type: String,
            default() {
                return 'Dataset'
            }
        }]
    }, 
    setup () {
        return {
            //v$: useVuelidate()
        }
    },
    data() {
        return {
            activeEmailAppend: [],
            messageTxt: '',
            thetoken: '',
            thestatus: false,
            datazappFile: '',
            fincount: 0,
            finalFilePath: ''
        }    
    },
    methods: {
        lookupEmailAddress() {
            console.log('test variables '+this.passedData+' filename only '+this.passedData.replace(/^.*[\\/]/, ''));
            const intialFormData = new FormData();
            intialFormData.append('filepath', this.passedData);
            intialFormData.append('thefilename',this.passedData.replace(/^.*[\\/]/, ''))
            const serializedData = new URLSearchParams(intialFormData).toString();
            console.log('the current serializaed data '+serializedData);
            
            axios({
                method: "POST",
                url: "/submit_bulk_append",
                data: serializedData
            })
            .then(
                (response) => {
                //console.log('Need to continue to next response, will receive status and token '+JSON.stringify(response));
                console.log('file submitted to datazap response ' + JSON.stringify(response));
                this.messageTxt = response.data.ResponseDetail.Message;
                this.thetoken = response.data.ResponseDetail.Token;
                this.thestatus = response.data.Status;
                this.checkEmailStatus();
            })
            .catch(error => {
                console.error('trying to get the file did not work ' + error + ' passed via get = ' + this.passedData);
            });
        },
        checkEmailStatus() {
            const formData = new FormData();
            formData.append("Token", this.thetoken);
            formData.append("ApiKey", "PDKTMPEUKR");
            formData.append("AppendModule", "1");
            axios({
                method: 'POST',
                url: 'https://secureapi.datazapp.com/Appendv2/AppendFile/FileStatus',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(
                (response) => {
                    console.log('file check status '+JSON.stringify(response.data));
                    this.messageTxt = response.data.Message;
                    this.thetoken = response.data.ResponseDetail.Token;
                    this.thestatus = response.data.Status;
                    this.fincount = response.data.ResponseDetail.TotalAppend;
                    console.log('the token ' + this.thetoken + ' the responding token '+response.data.ResponseDetail.Token);
                    console.log('the count ' + this.fincount);
                    if(this.thestatus == true) {
                        this.downloadFile();
                    } else {
                        setTimeout(this.checkEmailStatus(), 60000);
                    }
            })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });
        },
        downloadFile() {
            console.log('pre download token verify '+this.thetoken);
            const formData = new FormData();
            formData.append("token", this.thetoken);
            formData.append("filename",this.passedData.replace(/^.*[\\/]/, ''))
            axios({
                method: 'POST',
                url: '/datazap_download_final',
                data: formData
            }).then(
                (response) => {
                    console.log('file check status '+JSON.stringify(response.data));
                    this.$emit('decreaseEmailCount', this.fincount);
                    this.messageTxt = "File is completed";
                    this.finalFilePath = JSON.stringify(response.data);
            })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });
        },
        removePath(val) {
            val =  val.replace(/^.*[\\/]/, '').replace(/"/g, '')
            return val
        }
    },
    mounted() {  
        console.log('passed data is '+this.passedData); 
        console.log('passed Range is '+this.appendFilerange);   
        this.lookupEmailAddress();
    }
}
</script>